import handleFetch from './handleFetch';

const fetchPharmacies = (
  chainCode: string,
  zip: string,
  lat?: string,
  lng?: string,
  errorKey?: string
): Promise<Response | Error> => {
  let url = `${process.env.SAAS_LOCATION_ENDPOINT}?chainCode=${encodeURIComponent(chainCode)}&zip=${encodeURIComponent(
    zip
  )}`;
  if (lat && lng) url += `&lat=${encodeURIComponent(lat)}&lng=${encodeURIComponent(lng)}`;

  return handleFetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'x-api-key': process.env.SAAS_API_KEY || '',
    },
    errorKey: errorKey || 'Error fetching pharmacies.',
  });
};
export default fetchPharmacies;
